import { WidgetState } from "@/apps/MyStudyChoiceHeartWidget/models/store-viewmodel";
import actions from "@/apps/MyStudyChoiceHeartWidget/store/actions";
import mutations from "@/apps/MyStudyChoiceHeartWidget/store/mutations";
import getters from "@/apps/MyStudyChoiceHeartWidget/store/getters";
import { root } from "@/shared/store";

export default {
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters,
    modules: {
        root
    }
}
